import { Link } from 'react-router';
import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

export function StickyNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-base-100/80 backdrop-blur-xl shadow-lg shadow-base-300/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 py-4">
        <Link to="/">
          <div className="text-2xl font-extrabold tracking-tight">
            Hy<span className="text-primary">Pe</span>Ma
          </div>
          <p className="text-[7px] font-semibold uppercase tracking-[0.15em] text-base-content/30">
            Hyper Personalized Mail
          </p>
        </Link>

        {/* Desktop nav */}
        <div className="hidden lg:flex items-center gap-6">
          <a
            href="#how-it-works"
            className="text-sm text-base-content/50 hover:text-base-content transition-colors"
          >
            How it works
          </a>
          <a
            href="#pricing"
            className="text-sm text-base-content/50 hover:text-base-content transition-colors"
          >
            Pricing
          </a>
          <a
            href="#faq"
            className="text-sm text-base-content/50 hover:text-base-content transition-colors"
          >
            FAQ
          </a>
          <Link
            to="/docs/guide"
            className="text-sm text-base-content/50 hover:text-base-content transition-colors"
          >
            Academy
          </Link>
          <Link
            to="/docs/api-reference"
            className="text-sm text-base-content/50 hover:text-base-content transition-colors"
          >
            Developers
          </Link>
          <Link
            to="/login"
            className="btn btn-ghost btn-sm text-base-content/60"
          >
            Login
          </Link>
          <Link to="/onboarding" className="btn btn-primary btn-sm">
            Get started free
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="lg:hidden btn btn-ghost btn-sm btn-square"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="lg:hidden bg-base-100/95 backdrop-blur-xl border-t border-base-300/30 px-6 pb-6 space-y-2 animate-fade-in">
          <a
            href="#how-it-works"
            className="block py-2 text-sm text-base-content/60 hover:text-base-content"
            onClick={() => setMenuOpen(false)}
          >
            How it works
          </a>
          <a
            href="#pricing"
            className="block py-2 text-sm text-base-content/60 hover:text-base-content"
            onClick={() => setMenuOpen(false)}
          >
            Pricing
          </a>
          <a
            href="#faq"
            className="block py-2 text-sm text-base-content/60 hover:text-base-content"
            onClick={() => setMenuOpen(false)}
          >
            FAQ
          </a>
          <Link
            to="/docs/guide"
            className="block py-2 text-sm text-base-content/60 hover:text-base-content"
            onClick={() => setMenuOpen(false)}
          >
            Academy
          </Link>
          <Link
            to="/docs/api-reference"
            className="block py-2 text-sm text-base-content/60 hover:text-base-content"
            onClick={() => setMenuOpen(false)}
          >
            Developers
          </Link>
          <div className="pt-2 flex flex-col gap-2">
            <Link
              to="/login"
              className="btn btn-ghost btn-sm"
              onClick={() => setMenuOpen(false)}
            >
              Login
            </Link>
            <Link
              to="/onboarding"
              className="btn btn-primary btn-sm"
              onClick={() => setMenuOpen(false)}
            >
              Get started free
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
